import { useContext, createContext } from 'react';

const DetailsGroupContext = /*#__PURE__*/createContext({});
const useDetailsGroupContext = () => {
  return useContext(DetailsGroupContext);
};

export { DetailsGroupContext, useDetailsGroupContext };
